import * as Sentry from '@sentry/react'
const env = process.env.REACT_APP_ENV
const sentryDsn = process.env.REACT_APP_SENTRY_DSN

Sentry.init({
  dsn: sentryDsn,
  allowUrls: ['viewmychain.com'],

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  _experiments: {
    // Enable logs to be sent to Sentry.
    enableLogs: true,
  },

  integrations: [Sentry.browserTracingIntegration()],
  environment: env,
})
